module.exports = __webpack_public_path__ + "static/media/voix1.e6b2d78f.ogg";